export function isUserAuthorized(): boolean {
    return !!(window as any).__INITIAL_STATE__.userInfo;
}

export function getUserId(): string {
    if (!isUserAuthorized())
        return '';
    return window.__INITIAL_STATE__.userInfo.id;
}

export function isTravelAgent(): boolean {
    return !isTourist();
}

export function isTourist(): boolean {
    return !isUserAuthorized() || window.__INITIAL_STATE__.userInfo.roles.includes('Tourist');
}
